module.exports = __webpack_public_path__ + "static/media/Figure16.d5e9452d.jpg";